import { router } from '@inertiajs/react'
import { ItemsList } from '@/components/items/ItemsList'
import type { Item, Stream, PaginationInfo, FilterParams } from '@/components/items/types'

interface Props {
  items: Item[]
  streams: Stream[]
  pagination: PaginationInfo
}

// Build URL with filter params
function buildUrl(path: string, filters: FilterParams, page?: number) {
  const params = new URLSearchParams()
  if (page && page > 1) params.set('page', String(page))
  if (filters.streamId) params.set('stream', filters.streamId)
  if (filters.sourceType) params.set('source', filters.sourceType)
  if (filters.gemStatus && filters.gemStatus !== 'all') params.set('gem_status', filters.gemStatus)
  if (filters.reportStatus) params.set('report_status', filters.reportStatus)
  if (filters.dateFrom) params.set('from', filters.dateFrom)
  if (filters.dateTo) params.set('to', filters.dateTo)
  if (filters.search) params.set('q', filters.search)

  const queryString = params.toString()
  return queryString ? `${path}?${queryString}` : path
}

export default function ItemsIndex({ items, streams, pagination }: Props) {
  const handleView = (id: string) => {
    router.visit(`/items/${id}`)
  }

  const handleUploadCsv = () => {
    router.visit('/items/upload')
  }

  const handleFlagAsGem = (id: string) => {
    router.post(`/items/${id}/flag_as_gem`, {}, {
      preserveScroll: true,
      onSuccess: () => router.reload({ only: ['items'] })
    })
  }

  const handleUnflagGem = (id: string) => {
    router.delete(`/items/${id}/unflag_gem`, {
      preserveScroll: true,
      onSuccess: () => router.reload({ only: ['items'] })
    })
  }

  const handleDelete = (id: string) => {
    if (confirm('Are you sure you want to delete this item?')) {
      router.delete(`/items/${id}`, {
        preserveScroll: true,
        onSuccess: () => router.reload({ only: ['items'] })
      })
    }
  }

  const handlePageChange = (page: number, filters: FilterParams) => {
    router.visit(buildUrl('/items', filters, page), { preserveScroll: true })
  }

  const handleFilterChange = (filters: FilterParams) => {
    router.visit(buildUrl('/items', filters), { preserveScroll: true })
  }

  return (
    <ItemsList
      items={items}
      streams={streams}
      pagination={pagination}
      onView={handleView}
      onFlagAsGem={handleFlagAsGem}
      onUnflagGem={handleUnflagGem}
      onDelete={handleDelete}
      onUploadCsv={handleUploadCsv}
      onPageChange={handlePageChange}
      onFilterChange={handleFilterChange}
    />
  )
}
